import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Formik, Field as Fieldmik, FieldArray, ErrorMessage } from "formik";
import {
  Form as FormUi,
  Segment,
  Button,
  Container,
  Divider,
  Grid,
  GridColumn,
  Icon,
  Table,
} from "semantic-ui-react";
import * as yup from "yup";
import moment from "moment";
import { Checkbox } from "formik-semantic-ui";
import Axios from "axios";
import cogoToast from "cogo-toast";

import APP_CONSTANTS from "../../config/constants";

import UploadFile from "../formikInput/fileUpload";

import AddTitleBar from "../../components/titleBar/addTitleBar";
import LoadingPlaceholder from "../placeholder/loadingPlaceholder";

//Inputs
import { DateData } from "../formikInput/date";

//Add-Product
import AddProduct from "../purchaseOrder/addProduct";
import ActivePurchaseOrder from "./activePurchaseOrder";

//Dropdowns
import PurchaseOrderVendorDropdown from "../dropdowns/purchaseOrderVendorDropdown";
import PurchaseOrderBranchDropdown from "../dropdowns/purchaseOrderBranchDropdown";
import BranchDropdown from "../dropdowns/branchDropdown";
import VendorVehicleDropdown from "../dropdowns/vendorVehicleDropdown";

//Actions
import { createBill } from "../../redux/actions/billActions";
import {
  getVendorPurchaseOrder,
  updatePurchaseOrder,
  clearSelectPoData,
} from "../../redux/actions/purchaseOrderActions";
import SupportingDoc from "./supportingDoc";
import { MyTextArea } from "../formikInput/input";
import { LOCAL_STORAGE, hasMinValueForBillDate } from "../../config/const";

const AddBill = (props) => {
  const {
    createBill,
    getVendorPurchaseOrder,
    vendorPurchaseOrderPagination,
    vendorPurchaseOrderData,
    vendorPurchaseOrderLoading,
    updatePurchaseOrder,
    seletedPOData,
    clearSelectPoData
  } = props;

  //State
  const [activateManualPO, setActivateManualPO] = useState(false);
  const [vendorName, setVendorName] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [vendorDetails, setVendorDetails] = useState({});
  const [stateData, setStateData] = useState([]);
  const [gst, setGst] = useState("");
  const [vendorState, setVendorState] = useState("");
  const [vendorStateId, setVendorStateId] = useState("");
  const [initialize, setInitialize] = useState(false);
  const [branchCode, setBranchCode] = useState("");
  const [masterState, setMasterState] = useState("");
  const [vehicleData, setVehicleData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [activePOData, setActivePOData] = useState([]);
  const [activePOSum, setActivePOSum] = useState(0);

  const [purchaseOrderPagination, setPurchaseOrderPagination] = useState([]);
  const [purchaseOrderCurrentPage, setPurchaseOrderCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [loadingPO, setLoadingPO] = useState(false);
  let [selectedPO, setSelectedPO] = useState([])
  const [GSTExemptedReason, setGSTExemptedReason] = useState('');
  const [vendorPsLineGSTMappingData, setVendorPsLineGSTMappingData] = useState([])

  useEffect(()=>{
    clearSelectPoData()
  },[getVendorPurchaseOrder,vendorName])

  useEffect(() => {
    if (Object.keys(vendorDetails).length === 0)
      cogoToast.info("Select Partner Name first!");

      let activePOData = []
      vendorPurchaseOrderData && vendorName &&
      vendorPurchaseOrderData.map((o, i) => {
          let temp = {};
          temp.checkbox = false;
          temp.poId = o.poId;
          temp.poReferenceNo = o.poReferenceNo;
          temp.vendorCode = o.vendorId;
          temp.branchCode = o.branchId;
          temp.orderNo = o.orderNo;
          temp.vehicleNo = o.vehicleId;
          temp.poQuantity = o.poQuantity;
          temp.poAmount = o.poAmount;
          temp.poNumber = o.poNumber;
          temp.deliveryDate = o.deliveryDate ? o.deliveryDate : "";
          temp.sgstAmount = o.sgstAmount;
          temp.cgstAmount = o.cgstAmount;
          temp.igstAmount = o.igstAmount;
          temp.adjustment = o.adjustment;
          temp.totalOrderAmt = o.totalOrderAmt;
          temp.remarks = o.remarks;
          temp.gstTaxType = o.gstTaxType;
          temp.poDate = o.poDate;
          temp.tdsAmount = o.tdsAmount;
          temp.taxableAmount = o.taxableAmount;
          temp.totalDiscount = o.totalDiscount;
          temp.lrNo = o.lrNumbers ? o.lrNumbers : ''
          temp.vendorLrNo = o.vendorLrNumbers ? o.vendorLrNumbers : ''
          activePOData[i] = temp;
        });
        setActivePOData(activePOData);

    let token = localStorage.getItem("apiToken");
    let userId = localStorage.getItem("userId");
    let customerNo = localStorage.getItem("customerNo");

    Axios.get(
      `${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${customerNo}&userId=${userId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setStateData(response.data.resultSet);
      })
      .catch((error) => console.log(error));

    Axios.get(
      `${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${customerNo}&userId=${userId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setStateData(response.data.resultSet);
      })
      .catch((error) => console.log(error));
  }, [vendorPurchaseOrderData]);

  useEffect(() => {
    if(vendorId){
      Axios.get(
        `${APP_CONSTANTS.BASE_URL}/masters/vendorPSLineItemGSTMapping?vendorId=${vendorId}&customerNo=${LOCAL_STORAGE.customerNo}&userId=${LOCAL_STORAGE.userId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: LOCAL_STORAGE.userToken,
          },
        }
      )
        .then((response) => {
          setVendorPsLineGSTMappingData(response.data.resultSet);
        })
        .catch((error) => console.log(error));
    }
  }, [vendorId]);

  const handlePaginationChange = (activePage) => {
    //setInitialize(true);
    setLoadingPO(true);
    setPurchaseOrderCurrentPage(activePage);
    getPoData(activePage, searchText);
  };

  const handleSearchString = (searchString) => {
    //setInitialize(true);
    setLoadingPO(true);
    setPurchaseOrderCurrentPage(1)
    setSearchText(searchString.toString());
    getPoData(1, searchString);
  };

  const getPoData = (activePage, searchString) => {
    //setEditLoading(true);
    const edit = false;

    getVendorPurchaseOrder(
      null,
      vendorDetails.transporterCode,
      activePage,
      searchString,
      edit
    ).then(() => {
      //setEditLoading(false);
      setInitialize(false);
      setLoadingPO(false);
    });
  };

  const getVehicleData = (childData) => {
    setVehicleData(childData);
  };

  const getBranchData = (childData) => {
    setBranchData(childData);
    setVendorStateId(childData[0]?.vendorBranchStateId);
  };

  const getVendorDetails = (childData) => {
    setVendorDetails(childData);
  };

  const getBranchSelected = (childData) => {
    const branchDetails = vendorDetails.branches.find(
      (data) => data.vendorBranchCode === childData
    );
    const stateDetails = stateData.find(
      (data) => data.stateId === branchDetails.vendorBranchStateId
    );

    setGst(branchDetails?.vendorBranchGST);
    setVendorState(stateDetails?.state);
    setVendorStateId(stateDetails?.stateId);
    setBranchCode(branchDetails?.vendorBranchCode);
  };

  const getMasterBranchSelected = (branchCode, branchData, setFieldValue) => {
    const addedMasterBranchObject = branchData?.find(
      (data) => data?.branchCode === branchCode
    );
    setMasterState(addedMasterBranchObject?.stateId);

    if (addedMasterBranchObject?.gstChargeMechanism == "RCM") {
        setGSTExemptedReason('RCM')
    } else {
        setGSTExemptedReason('')
    }

    let token = localStorage.getItem("apiToken");
    let userId = localStorage.getItem("userId");
    let customerNo = localStorage.getItem("customerNo");

    let headerData = {
      customerNo: customerNo,
      userId: userId,
      branchCode: branchCode,
    };

    Axios.post(
      `${APP_CONSTANTS.BASE_URL}/purchase/bill/getBillNumber`,
      headerData,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setFieldValue("billNumber", response.data.data);
      })
      .catch((error) => console.log(error));
  };

  //ArrayHelper
  Array.prototype.sum = function (prop) {
    var total = 0;
    for (var i = 0, _len = this.length; i < _len; i++) {
      total += this[i][prop];
    }
    return total;
  };


  //Formik
  const initialValues = {
    vendorName: vendorName,
    billNumber: "",
    billDate: "",
    billId: "",
    expectedPaymentDate: "",
    billReceiptDate: "",
    chargeMechanismRCM: false,
    branch: "",
    vendorBranch: "",
    billReferenceNo: "",
    poReferenceNo: "",
    vehicleNumber: "",
    activePoAddedTotal: "",
    manualPoAddedTotal: "",
    isGstApplicable: true,
    productDetails: [
      {
        productName: "",
        startDate: "",
        endDate: "",
        hsnCode: "",
        sacCode: "",
        quantity: 1,
        rate: "",
        discount: "",
        discountType: "1",
        iGstPercent: 0,
        iGst: 0,
        cGstPercent: 0,
        cGst: 0,
        sGstPercent: 0,
        sGst: 0,
        amount: 0,
      },
    ],
    supportDoc: [
      {
        billId: "0",
        supportingDocumentTypeId: "0",
        supportingDocumentTypeName: "",
        fileUrl: "",
      },
    ],
    fileUpload: "",
    fileSize: "",
    // activePODetails: activePOData,
    finalAmount: "",
    activePOSelected: [],
    remarks: ''
  };

  const validateSchema = yup.object().shape({
    vendorName: yup.mixed().required("Vendor Name is Required"),
    billDate: yup.mixed().required("Bill Date is Required"),
    branch: yup.mixed().required("Branch is Required"),
    expectedPaymentDate: yup
      .mixed()
      .required("Expected Payment Date is Required"),
    billReferenceNo: yup.mixed().required("Bill Reference Number is Required"),
    fileUpload: yup.mixed().when(["fileSize"], (fileSize, schema) => {
      return fileSize
        ? schema.test(
          "fileSize",
          "File size should be less than 5MB",
          (value) => {
            return value && value.fileList[0].size <= 5000000;
          }
        )
        : schema;
    }),
  });

  const onSubmit = (values, onSubmitProps) => {
    console.log("Product Onsubmit", values);

    const customerNumber = localStorage.getItem("customerNo");
    const userId = localStorage.getItem("userId");

    let psLineItems = [];
    values.productDetails.map((product, index) => {
      let temp = {};
      temp.psCode = product.productCode;
      temp.psName = product.productName;
      temp.startDate = product.startDate;
      temp.endDate = product.endDate;
      temp.psQty = product.quantity;
      temp.psPrice = product.rate;
      temp.psAmount = product.rate * product.quantity;
      temp.igstPercent = product.iGstPercent;
      temp.igstAmount = product.iGst;
      temp.cgstPercent = product.cGstPercent;
      temp.cgstAmount = product.cGst;
      temp.sgstPercent = product.sGstPercent;
      temp.sgstAmount = product.sGst;
      temp.tdsTaxSectionId = product.tdsId;
      temp.tdsTaxCode = product.tdsTaxCode;
      temp.discount = product.discount;
      temp.finalDiscount = product.discount;
      temp.discountType = product.discountType;
      temp.taxableAmount = product.rate * product.quantity - product.discount;
      psLineItems[index] = temp;
    });

    let exLineItems = [];
    values.activeSOSelected.forEach((product, index) => {
      let temp = {};
      temp.poReferenceNo = product.poReferenceNo;
      exLineItems[index] = temp;
    });

    let supportingDocArray = [];
    values.supportDoc.map((document, documentIndex) => {
      let temp = {};
      temp.supportingDocumentTypeName = document.supportingDocumentTypeName;
      temp.supportingDocumentTypeId = document.supportingDocumentTypeId;
      supportingDocArray[documentIndex] = temp;
    });

    let manualPoArray = [
      {
        poReferenceNo: values.poReferenceNo,
        vendorCode: values.vendorName,
        branchCode: values.vendorBranch,
        vehicleNo: values.vehicleNumber,
        poQuantity: psLineItems.length,
        poAmount: values.manualPoAddedTotal,
        sgstAmount: psLineItems.sum("sgstAmount"),
        cgstAmount: psLineItems.sum("cgstAmount"),
        igstAmount: psLineItems.sum("igstAmount"),
        adjustment: 0,
        totalOrderAmt: values.manualPoAddedTotal,
        remarks: values.remarks,
        gstTaxType: 0,
        poDate: new Date(),
        tdsAmount: 0,
        taxableAmount: psLineItems.sum("taxableAmount"),
        totalDiscount: psLineItems.sum("discount"),
        psDetails: psLineItems,
      },
    ];

    if (values.poReferenceNo.length === 0) {
      manualPoArray = [];
    }

    // if(activateManualPO){
    //     exLineItems = [];
    // } else {
    //     manualPoArray = [];
    // }

    let activePoAmountSum = 
      values.activeSOSelected.length > 0 ? 
        values.isGstApplicable ? 
          Number(values.activeSOSelected.reduce((prev, next) => parseFloat(prev) + parseFloat(next.poAmount), 0)).toFixed(2) :
          Number(values.activeSOSelected.reduce((prev, next) => parseFloat(prev) + parseFloat(next.taxableAmount), 0)).toFixed(2)
        : 0

    const createBillData = {
      customerNo: customerNumber,
      userId: userId,
      billReferenceNo: "",
      billNo: values.billNumber,
      vendorCode: values.vendorName,
      branchCode: values.branch,
      vendorBranchCode: values.vendorBranch,
      billAmount: isNaN(values.manualPoAddedTotal) ? Number(activePoAmountSum) : Number(activePoAmountSum) + Number(values.manualPoAddedTotal),
      statusCode: "",
      fileUpload: values.fileUpload && values.fileUpload.base64.split(",")[1],
      expectedPaymentDate: moment(values.expectedPaymentDate).format(
        "DD-MM-YYYY"
      ),
      billReferenceNo: values.billReferenceNo,
      billDate: moment(values.billDate).format("DD-MM-YYYY"),
      totalPoAmount: Number(activePoAmountSum) + Number(values.manualPoAddedTotal),
      termsConditions: "",
      remarks: values.remarks,
      gstTaxType: 2,
      totalTaxableAmount: 0,
      totalSgstAmount: manualPoArray ? manualPoArray.sgstAmount : "",
      totalCgstAmount: manualPoArray ? manualPoArray.cgstAmount : "",
      totalIgstAmount: manualPoArray ? manualPoArray.igstAmount : "",
      totalTdsAmount: 0,
      departMentCategoryCode: 0,
      irn: "",
      hsnCode: "",
      noOfLineItems: psLineItems.length,
      isPartialBill: 0,
      grn: "",
      grnDateTime: "",
      billReceiptDate: moment(values.billReceiptDate).format("DD-MM-YYYY"),
      poDate: "",
      totalOrderAmt: values.activeSOSelected.length > 0 && Number(values.activeSOSelected.map(item => item.poAmount).reduce((prev, next) => parseFloat(prev) + parseFloat(next))).toFixed(2),
      adjustment: 0,
      poAmount: values.activeSOSelected.length > 0 && Number(values.activeSOSelected.map(item => item.poAmount).reduce((prev, next) => parseFloat(prev) + parseFloat(next))).toFixed(2),
      poQuantity: 1,
      tdsAmount: 0,
      taxableAmount: 2,
      totalDiscount: 0,
      isGstApplicable: values.isGstApplicable ? "1" : "0",
      existingPoArray: exLineItems,
      manualPoArray: manualPoArray,
      supportingDocumentTypeArray: supportingDocArray,
    };

    createBill(createBillData).then(() => {
      setTimeout(() => {
        onSubmitProps.setSubmitting(false);
      }, 4000);
    });
  };

  return (
    <React.Fragment>
      <AddTitleBar title="New Bill" LinkName="/bill" />
      <div className="m-2">
        <Formik
          enableReinitialize={initialize}
          initialValues={initialValues}
          validationSchema={validateSchema}
          onSubmit={onSubmit}
        >
          {({ touched, errors, values, isSubmitting, handleSubmit, setFieldValue }) => {
            const { productDetails, manualPoAddedTotal } =
              values;

            let selectedPoTotal = [];
            let manualPoTotal = [];
            let selectedPO = [];

            activePOData.filter((item) => {
              if (item.checkbox === true) {
                if (values.isGstApplicable) {
                  selectedPoTotal.push(item.poAmount);
                  selectedPO.push(item);
                } else {
                  selectedPoTotal.push(item.taxableAmount);
                  selectedPO.push(item);
                }
              }
            });

            productDetails.filter((item) => {
              if (values.isGstApplicable) {
                manualPoTotal.push(item.amount);
              } else {
                manualPoTotal.push(item.taxableAmount);
              }
            });

            values.activePoAddedTotal = selectedPoTotal
              .reduce((total, obj) => parseFloat(obj) + parseFloat(total), 0)
              .toFixed(2);
            values.manualPoAddedTotal = manualPoTotal
              .reduce((total, obj) => parseFloat(obj) + parseFloat(total), 0)
              .toFixed(2);

            const manualPoAddedTotalNanCheck = isNaN(values.manualPoAddedTotal)
              ? "0.00"
              : values.manualPoAddedTotal;

            values.finalAmount = Number(
              +manualPoAddedTotalNanCheck + +values.activePoAddedTotal
            ).toFixed(2);

            values.activePOSelected = selectedPO;
            // setSelectedPO(values.activePOSelected )

            values.fileSize =
              values.fileUpload && values.fileUpload.fileList
                ? values.fileUpload.fileList[0].size
                : "";


            return (
              <>
                <Segment>
                  <div className="ui form tiny">
                    <FormUi.Group>
                      <FormUi.Field width="2">
                        <label className="labelName mt-2">Partner Name <span className='mandatoryMark'>*</span></label>
                      </FormUi.Field>
                      <FormUi.Field width="5">
                        <Fieldmik
                          component={PurchaseOrderVendorDropdown}
                          name="vendorName"
                          placeholder="Partner Name"
                          getVendorDetails={getVendorDetails}
                          getBranchData={getBranchData}
                          getVendorPurchaseOrder={getVendorPurchaseOrder}
                          setVendorName={setVendorName}
                          getVehicleData={getVehicleData}
                          setCurrentPage={setPurchaseOrderCurrentPage}
                          setVendorId={setVendorId}
                          //setInitialize={setInitialize}
                        />
                        {touched.vendorName && errors.vendorName ? (
                          <strong className="w3-text-red w3-tiny font-weight-bold">
                            {errors.vendorName}
                          </strong>
                        ) : (
                          ""
                        )}
                      </FormUi.Field>
                      <FormUi.Field width="1" />
                      <FormUi.Field width="3">
                        <label className="labelName mt-2">Partner Branch</label>
                      </FormUi.Field>
                      <FormUi.Field width="3">
                        <Fieldmik
                          component={PurchaseOrderBranchDropdown}
                          name="vendorBranch"
                          getBranchSelected={getBranchSelected}
                          branchData={branchData}
                        />
                        {touched.vendorBranch && errors.vendorBranch ? (
                          <strong className="w3-text-red w3-tiny font-weight-bold">
                            {errors.vendorBranch}
                          </strong>
                        ) : (
                          ""
                        )}
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      <FormUi.Field width="4">
                        <label className="labelName mt-2">Bill Date <span className='mandatoryMark'>*</span></label>
                      </FormUi.Field>
                      <FormUi.Field width="3">
                        <DateData
                          name={`billDate`}
                          autoComplete="off"
                          popperClassName="dateTime"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Date"
                          selected={values.billDate}
                          maxDate={new Date()}
                          minDate={hasMinValueForBillDate ? new Date(moment().subtract(45, 'days')) : null}
                          timeIntervals={5}
                          updateOnChangeName='expectedPaymentDate'
                          updateOnChangeValueOffsetDays={60}
                          customInput={
                            <FormUi.Input
                              error={values.billDate ? false : true}
                              autoComplete="off"
                              className="dateWidth"
                              icon="time"
                              iconPosition="left"
                            />
                          }
                        />
                        {touched.billDate && errors.billDate ? (
                          <strong className="w3-text-red w3-tiny font-weight-bold">
                            {errors.billDate}
                          </strong>
                        ) : (
                          ""
                        )}
                      </FormUi.Field>
                      <FormUi.Field width="1" />
                      <FormUi.Field width="3">
                        <label className="labelName mt-2">Branch <span className='mandatoryMark'>*</span></label>
                      </FormUi.Field>
                      <FormUi.Field width="3">
                        <Fieldmik
                          component={BranchDropdown}
                          name="branch"
                          placeholder="Branch"
                          getMasterBranchSelected={getMasterBranchSelected}
                        />
                        {touched.branch && errors.branch ? (
                          <strong className="w3-text-red w3-tiny font-weight-bold">
                            {errors.branch}
                          </strong>
                        ) : (
                          ""
                        )}
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      <FormUi.Field width="4">
                        <label className="labelName mt-2">
                          Expected Payment Date <span className='mandatoryMark'>*</span>
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width="3">
                        <DateData
                          name={`expectedPaymentDate`}
                          autoComplete="off"
                          popperClassName="dateTime"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Date"
                          selected={values.expectedPaymentDate}
                          minDate={values.billDate}
                          timeIntervals={5}
                          customInput={
                            <FormUi.Input
                              autoComplete="off"
                              className="dateWidth"
                              icon="time"
                              iconPosition="left"
                            />
                          }
                        />
                        {touched.expectedPaymentDate &&
                          errors.expectedPaymentDate ? (
                          <strong className="w3-text-red w3-tiny font-weight-bold">
                            {errors.expectedPaymentDate}
                          </strong>
                        ) : (
                          ""
                        )}
                      </FormUi.Field>
                      <FormUi.Field width="1" />
                      <FormUi.Field width="3">
                        <label className="labelName mt-2">
                          Bill Reference Number <span className='mandatoryMark'>*</span>
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width="3">
                        <Fieldmik
                          name="billReferenceNo"
                          placeholder="Reference Number"
                        />
                        {touched.billReferenceNo && errors.billReferenceNo ? (
                          <strong className="w3-text-red w3-tiny font-weight-bold">
                            {errors.billReferenceNo}
                          </strong>
                        ) : (
                          ""
                        )}
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      <FormUi.Field width="4">
                        <label className="labelName mt-2">
                          Bill Reciept Date
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width="3">
                        <DateData
                          name={`billReceiptDate`}
                          autoComplete="off"
                          popperClassName="dateTime"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Date"
                          selected={values.billReceiptDate}
                          minDate={new Date()}
                          timeIntervals={5}
                          customInput={
                            <FormUi.Input
                              autoComplete="off"
                              className="dateWidth"
                              icon="time"
                              iconPosition="left"
                            />
                          }
                        />
                        {touched.billReceiptDate && errors.billReceiptDate ? (
                          <strong className="w3-text-red w3-tiny font-weight-bold">
                            {errors.billReceiptDate}
                          </strong>
                        ) : (
                          ""
                        )}
                      </FormUi.Field>
                      <FormUi.Field width="1" />

                      <FormUi.Field width="3">
                        <label className="labelName mt-2">Upload Invoice</label>
                      </FormUi.Field>
                      <FormUi.Field width="4">
                        <Fieldmik
                          component={UploadFile}
                          name="fileUpload"
                          size="tiny"
                          typer={[".pdf"]}
                          value={values.fileUpload}
                          buttonName={values.fileUpload ? "Selected" : "Select"}
                        />
                        {values.fileUpload ? (
                          <strong className="w3-text-green w3-tiny font-weight-bold">
                            {values.fileUpload.fileList[0].name}
                          </strong>
                        ) : (
                          ""
                        )}
                        <br />
                        {/* {touched.fileUpload && errors.fileUpload ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.fileUpload}</strong> : ''} */}
                        {values.fileSize && values.fileSize >= 5000000 ? (
                          <strong className="w3-text-red w3-tiny font-weight-bold">
                            File size should be less than 5MB
                          </strong>
                        ) : (
                          ""
                        )}
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      <FormUi.Field width="4">
                        <label className="labelName mt-2">Bill Number</label>
                      </FormUi.Field>
                      <FormUi.Field width="3">
                        <Fieldmik
                          name="billNumber"
                          placeholder="Bill Number"
                          readOnly
                        />
                        {touched.billNumber && errors.billNumber ? (
                          <strong className="w3-text-red w3-tiny font-weight-bold">
                            {errors.billNumber}
                          </strong>
                        ) : (
                          ""
                        )}
                      </FormUi.Field>

                      <FormUi.Field width="1" />
                      <FormUi.Field width="3">
                        <label className="labelName mt-2">
                          Is GST Applicable?
                        </label>
                      </FormUi.Field>
                      <FormUi.Field className="mt-2">
                        <Checkbox
                          name={`isGstApplicable`}
                          value={values.isGstApplicable}
                        // inputProps={{disabled: viewmode}}
                        />
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      <FormUi.Field width="3">
                        <label className="labelName mt-2">
                          Remarks
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width="4">
                        <Fieldmik component={MyTextArea} name="remarks" placeholder="remarks" />
                        {touched.remarks && errors.remarks ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.remarks}</strong> : ''}
                      </FormUi.Field>
                    </FormUi.Group>
                  </div>
                </Segment>

                <Segment compact>
                  <SupportingDoc />
                </Segment>

                <Segment>
                  <div className="ui form tiny">
                    <Button
                      type="button"
                      onClick={() => {
                        setActivateManualPO(false);
                        setInitialize(false);
                      }}
                      style={{ borderRadius: "5px 5px 0px 0px" }}
                      size="small"
                      toggle
                      active={!activateManualPO}
                    >
                      Active Purchase Order
                    </Button>
                    <Button
                      type="button"
                      onClick={() => {
                        setActivateManualPO(true);
                        setInitialize(false);
                      }}
                      style={{ borderRadius: "5px 5px 0px 0px" }}
                      size="small"
                      toggle
                      active={activateManualPO}
                    >
                      New Purchase Order
                    </Button>

                    {/* FieldArray Component */}
                    {activateManualPO ? (
                      <>
                        <Container className="m-2">
                          <div className="ui form tiny">
                            <FormUi.Group>
                              <FormUi.Field width="3">
                                <label className="labelName mt-2">
                                  Vehicle Number
                                </label>
                              </FormUi.Field>
                              <FormUi.Field width="3">
                                <Fieldmik
                                  component={VendorVehicleDropdown}
                                  name="vehicleNumber"
                                  placeholder="Vehicle Number"
                                  vehicleData={vehicleData}
                                  value={values.vehicleNumber}
                                />
                                {touched.vehicleNumber &&
                                  errors.vehicleNumber ? (
                                  <strong className="w3-text-red w3-tiny font-weight-bold">
                                    {errors.vehicleNumber}
                                  </strong>
                                ) : (
                                  ""
                                )}
                              </FormUi.Field>
                              <FormUi.Field width="2" />
                              <FormUi.Field width="3">
                                <label className="labelName mt-2">
                                  PO Reference Number
                                </label>
                              </FormUi.Field>
                              <FormUi.Field width="3">
                                <Fieldmik
                                  name="poReferenceNo"
                                  placeholder="Reference Number"
                                />
                                {touched.poReferenceNo &&
                                  errors.poReferenceNo ? (
                                  <strong className="w3-text-red w3-tiny font-weight-bold">
                                    {errors.poReferenceNo}
                                  </strong>
                                ) : (
                                  ""
                                )}
                              </FormUi.Field>
                            </FormUi.Group>
                          </div>
                        </Container>

                        <AddProduct
                          billmode={true}
                          masterState={masterState}
                          vendorStateId={vendorStateId}
                          isGstApplicable={values?.chargeMechanismRCM ? GSTExemptedReason ? false : true : true }
                          vendorPsLineGSTMappingData={vendorPsLineGSTMappingData}
                          activePOSum={values.activePoAddedTotal}
                        />
                      </>
                    ) : loadingPO ? (
                      <>
                        <LoadingPlaceholder />
                      </>
                    ) : (
                      <ActivePurchaseOrder
                        masterState={masterState}
                        vendorStateId={vendorStateId}
                        updatePurchaseOrder={updatePurchaseOrder}
                        getVendorPurchaseOrder={getVendorPurchaseOrder}
                        setInitialize={setInitialize}
                        purchaseOrderPaginationData={
                          vendorPurchaseOrderPagination
                        }
                        handlePaginationChangeCall={handlePaginationChange}
                        handleSearchStringCall={handleSearchString}
                        searchTextProps={searchText}
                        purchaseOrderCurrentPageData={purchaseOrderCurrentPage}
                        hidePagination={vendorName.length > 0 ? false : true}
                        vendorName={vendorName}
                        activePOs={activePOData}
                      />
                    )}
                  </div>
                  <Divider />
                </Segment>

                <center>
                  <Button
                    style={{ marginBottom: "75px" }}
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    size="mini"
                    primary
                    type="submit"
                  >
                    Submit
                  </Button>
                </center>
              </>
            );
          }}
        </Formik>
      </div>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => ({
  vendorPurchaseOrderData:
    state.getVendorPurchaseOrderData.vendorPurchaseOrder.data,
  vendorPurchaseOrderPagination:
    state.getVendorPurchaseOrderData.vendorPurchaseOrder.pagination,
  vendorPurchaseOrderLoading: state.getVendorPurchaseOrderData.isLoading,
  seletedPOData: state.getSelectedPurchaseOrderData
});

export default connect(mapStatetoProps, {
  createBill,
  getVendorPurchaseOrder,
  updatePurchaseOrder,
  clearSelectPoData
})(AddBill);
